import { TABLE_WIDTH_IN_SMALL_SCREEN } from '../../../constants';

// 最小页面宽度下，Priority列宽
export const PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN = 20;
// 最小页面宽度下，Project列宽
const PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN = 280;
// 最小页面宽度下，Gate Review列宽
export const MILESTONE_COLUMN_WIDTH_IN_SMALL_SCREEN = 150;
// 最小页面宽度下，Gate Review Date列宽
export const MILESTONE_DATE_COLUMN_WIDTH_IN_SMALL_SCREEN = 170;
// 最小页面宽度下，Status列宽
export const STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN = 150;
// 最小页面宽度下，其余列宽
const COMMON_COLUMN_WIDTH_IN_SMALL_SCREEN =
  (TABLE_WIDTH_IN_SMALL_SCREEN -
    (PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN +
      PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN +
      MILESTONE_COLUMN_WIDTH_IN_SMALL_SCREEN +
      MILESTONE_DATE_COLUMN_WIDTH_IN_SMALL_SCREEN +
      STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN)) /
  2;

// Priority列宽（百分比）
export const PRIORITY_COLUMN_WIDTH = `${
  (PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
// Project列宽（百分比）
export const PROJECT_COLUMN_WIDTH = `${
  (PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
// Gate Review列宽
export const MILESTONE_COLUMN_WIDTH = `${
  (MILESTONE_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
// Review Date列宽
export const MILESTONE_DATE_COLUMN_WIDTH = `${
  (MILESTONE_DATE_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 90
}%`;
// Status列宽（百分比）
export const STATUS_COLUMN_WIDTH = `${
  (STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 120
}%`;
// 其余列宽（百分比）
export const COMMON_COLUMN_WIDTH = `${
  (COMMON_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
